import { getAnalyticsItems } from '@src/domains/analytics/core/getAnalyticsItems';
import { getOrderSaleItems, type Order } from '@src/domains/orders';

export const getOrderAnalyticsData = (order: Order) => {
  const items = getAnalyticsItems(getOrderSaleItems(order));

  return {
    orderId: order.id,
    items,
    itemsCount: items.length,
    value: order.finalAmountCents / 100,
    paymentMethod: order.lastTransaction?.paymentMethod.code,
  };
};
